export const CONTACT = {
  email: "randy@rlp-photography.com",
  phone: "210-421-0409",
  phoneHref: "tel:+12104210409",
  location: "San Antonio, Texas",
  instagram: "@rlpphotographystudio",
  instagramHref: "https://instagram.com/rlpphotographystudio",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/xdoqv8oh_RLP%20Logo%20Redo%20%282%29.png",
};

const RLP = {
  bandGroup: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/bxxiqpol_Elevate%20Band%20Photo.webp",
  mikeMcLean: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/3x3ecz3l_Band%20Promo%204.png",
  keithGerson: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/oex64vn8_Band%20Promo%205.png",
  portrait: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/eecok9rb_7L7A8958.webp",
  headshotExec: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/nqbispgk_Corporate%20haeshot%201.webp",
  headshotFinance: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/56ehogf2_Financial%20Firm.webp",
  headshotLaw3: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/ld2i2fcz_Law%20Firm%203.webp",
  headshotLaw: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/cswvlv83_Law%20Firm.webp",
  headshotOffice: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/l7kkn5xx_Office%20Location.webp",
  uncleBrent: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/24dppqtq_Screenshot%202026-07-24%20at%2012.47.51%E2%80%AFPM.png",
  bassLive: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/sh8hb6ue_QM1A9313.webp",
  giovanna: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/m4jkgkc1_RLP%20Headshot%20Giovanna%20.webp",
  austinMedia: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/qyk3whc0_Austin%20Media.webp",
  medical: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/6rp9uf6f_Medical%20facility.webp",
  chasingGhost: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/wu5o9hca_New%20Music%20Video%20%E2%80%9CChasing%20Your%20Ghost%E2%80%9D.webp",
  brandingMeeting: "https://customer-assets-jt897jd0.emergentagent.net/job_headshot-pro-36/artifacts/bpdw0dtm_images%20%2855%29.jpeg",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1621024994278-e409544f4085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxwaG90b2dyYXBoZXIlMjBjYW1lcmElMjBzdHVkaW98ZW58MHx8fHwxNzg0OTA3NDAwfDA&ixlib=rb-4.1.0&q=85",
  heroConcert: "https://images.unsplash.com/photo-1558620013-a08999547a36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxkcmFtYXRpYyUyMGNvbmNlcnQlMjBzdGFnZSUyMGxpZ2h0aW5nJTIwcGVyZm9ybWFuY2V8ZW58MHx8fHwxNzg0OTA3NDgyfDA&ixlib=rb-4.1.0&q=85",
  headshotMan: "https://images.pexels.com/photos/37605831/pexels-photo-37605831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  headshotWoman: "https://images.pexels.com/photos/29852852/pexels-photo-29852852.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    num: "01",
    title: "Corporate Headshots",
    titleItalic: "Headshots",
    desc: "Executive portraits and team headshots that build instant credibility. Consistent lighting, on-location or in-studio, delivered fast.",
    image: RLP.headshotOffice,
    pos: "object-top",
    tags: ["Executive", "Team", "LinkedIn"],
  },
  {
    num: "02",
    title: "Business Branding",
    titleItalic: "Branding",
    desc: "Product, workspace, and lifestyle imagery that tells your company's story. A cohesive visual identity for web, social, and print.",
    image: RLP.brandingMeeting,
    pos: "object-center",
    tags: ["Product", "Lifestyle", "Editorial"],
  },
  {
    num: "03",
    title: "Concerts & Live",
    titleItalic: "Live",
    desc: "High-energy concert and event coverage. Capturing the light, the crowd, and the moment the room comes alive.",
    image: RLP.bandGroup,
    tags: ["Concerts", "Events", "Tour"],
  },
];

export const GALLERY = [
  { src: RLP.headshotExec, label: "Corporate · Executive", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.headshotFinance, label: "Corporate · Financial", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.headshotLaw, label: "Corporate · Business", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.headshotLaw3, label: "Corporate · Legal", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.headshotOffice, label: "Branding · On Location", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.austinMedia, label: "Corporate · Media", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.giovanna, label: "Corporate · Portrait", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.medical, label: "Corporate · Medical", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-top" },
  { src: RLP.portrait, label: "Studio · Editorial", span: "md:col-span-4", ratio: "aspect-[4/5]", pos: "object-[center_30%]" },
  { src: RLP.bandGroup, label: "Live · Elevate Classic Rock", span: "md:col-span-6", ratio: "aspect-[16/10]", pos: "object-center" },
  { src: RLP.bassLive, label: "Live · On Stage", span: "md:col-span-6", ratio: "aspect-[16/10]", pos: "object-center" },
  { src: RLP.mikeMcLean, label: "Live · Mike McLean", span: "md:col-span-5", ratio: "aspect-[3/4]", fit: "object-contain" },
  { src: RLP.keithGerson, label: "Live · Keith Gerson", span: "md:col-span-7", ratio: "aspect-[4/3]", fit: "object-contain" },
  { src: RLP.uncleBrent, label: "Live · Uncle Brent & the Nostone", span: "md:col-span-9", ratio: "aspect-[16/9]", fit: "object-contain" },
  { src: RLP.chasingGhost, label: "Live · \"Chasing Your Ghost\" Music Video", span: "md:col-span-9", ratio: "aspect-[3/2]", fit: "object-contain" },
];

export const SERVICE_OPTIONS = [
  "Corporate Headshots",
  "Business Branding",
  "Concert / Live Event",
  "Other",
];

export const PACKAGES = [
  { name: "Corporate Headshots", price: "125" },
  { name: "Business Branding", price: "300" },
  { name: "Concert / Live Event", price: "500", note: "incl. short video reels" },
];
